import React, { PropTypes } from "react";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";
import { TextInput } from "../common/form";
import { Link } from "react-router";
import validationUtils from "../../utils/ValidationUtils";
import { bindActionCreators } from "redux";
import * as loginActions from "../login/loginActions";
import { connect } from "react-redux";

const ForgotPasswordForm = (props, context) => {
  const formatMessage = context.intl.formatMessage;
  const {
    handleSubmit,
    emailAddress,
    onChange,
    loginActions: { clearErrors },
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          id="username"
          name="username"
          type="text"
          className="login"
          component={TextInput}
          placeholder={formatMessage({ id: "resetPassword.username" })}
          props={onChange}
        />

        <Field
          id="emailAddress"
          name="emailAddress"
          type="text"
          className="login"
          component={TextInput}
          placeholder={formatMessage({ id: "resetPassword.emailAddress" })}
          props={onChange}
        />

        <div>
          <Link to="/login" onClick={clearErrors}>
            <FormattedMessage id="resetPassword.goToLogin" />
          </Link>
        </div>

        <button type="submit" className="btn btn-lg btn-primary">
          {!emailAddress ? (
            <FormattedMessage id="resetPassword.submit" />
          ) : (
            <FormattedMessage id="resetPassword.resend" />
          )}
        </button>
      </form>
    </div>
  );
};

ForgotPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  emailAddress: PropTypes.string,
  loginActions: PropTypes.shape({
    clearErrors: PropTypes.func,
  }),
};

ForgotPasswordForm.contextTypes = {
  intl: intlShape,
};

const RESET_FORM_VALIDATION_RULES = {
  username: {
    isRequiredTrim: {
      value: true,
    },
  },
  emailAddress: {
    isRequiredTrim: {
      value: true,
    },
    regex: {
      value: {
        pattern: /.+@.+\..+$/i,
        customMessageKey: "validation.customMessages.emailAddressRegex",
      },
    },
  },
};

function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
  };
}

export default reduxForm({
  form: "passwordReset", // a unique identifier for this form
  validate: (values) =>
    validationUtils.validate(values, RESET_FORM_VALIDATION_RULES),
})(connect(undefined, mapDispatchToProps)(ForgotPasswordForm));



// WEBPACK FOOTER //
// ./src/components/forgot-password/ForgotPasswordForm.js